/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Demo_SubtitleInputs */

const en_landing_demo_subtitle = /** @type {(inputs: Landing_Demo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch how Alchema tailors your resume, optimizes your ATS score, and prepares you for interviews -- all powered by EU-native AI.`)
};

const de_landing_demo_subtitle = /** @type {(inputs: Landing_Demo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlebe, wie Alchema deinen Lebenslauf anpasst, deinen ATS-Score optimiert und dich auf Vorstellungsgespraeche vorbereitet -- alles mit europaeischer KI.`)
};

const fr_landing_demo_subtitle = /** @type {(inputs: Landing_Demo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regarde comment Alchema adapte ton CV, optimise ton score ATS et te prépare aux entretiens — le tout propulsé par une IA européenne.`)
};

const es_landing_demo_subtitle = /** @type {(inputs: Landing_Demo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mira cómo Alchema adapta tu currículum, optimiza tu puntuación ATS y te prepara para entrevistas -- todo impulsado por IA europea.`)
};

const it_landing_demo_subtitle = /** @type {(inputs: Landing_Demo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda come Alchema personalizza il tuo curriculum, ottimizza il punteggio ATS e ti prepara per i colloqui — tutto con AI nativa europea.`)
};

const nl_landing_demo_subtitle = /** @type {(inputs: Landing_Demo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk hoe Alchema je CV op maat maakt, je ATS-score optimaliseert en je voorbereidt op gesprekken — allemaal aangedreven door EU-native AI.`)
};

const pl_landing_demo_subtitle = /** @type {(inputs: Landing_Demo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz, jak Alchema dostosowuje Twoje CV, optymalizuje wynik ATS i przygotowuje do rozmów — wszystko zasilane przez europejskie AI.`)
};

const fi_landing_demo_subtitle = /** @type {(inputs: Landing_Demo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katso, miten Alchema räätälöi ansioluettelosi, optimoi ATS-pisteesi ja valmentaa sinut haastatteluihin — kaikki EU-natiivilla tekoälyllä.`)
};

const da_landing_demo_subtitle = /** @type {(inputs: Landing_Demo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se, hvordan Alchema tilpasser dit CV, optimerer din ATS-score og forbereder dig til samtaler — alt drevet af EU-baseret AI.`)
};

const sv_landing_demo_subtitle = /** @type {(inputs: Landing_Demo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se hur Alchema anpassar ditt CV, optimerar din ATS-poäng och förbereder dig för intervjuer -- allt drivet av EU-native AI.`)
};

/**
* | output |
* | --- |
* | "Watch how Alchema tailors your resume, optimizes your ATS score, and prepares you for interviews -- all powered by EU-native AI." |
*
* @param {Landing_Demo_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_demo_subtitle = /** @type {((inputs?: Landing_Demo_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Demo_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_demo_subtitle(inputs)
	if (locale === "fr") return fr_landing_demo_subtitle(inputs)
	if (locale === "es") return es_landing_demo_subtitle(inputs)
	if (locale === "it") return it_landing_demo_subtitle(inputs)
	if (locale === "nl") return nl_landing_demo_subtitle(inputs)
	if (locale === "pl") return pl_landing_demo_subtitle(inputs)
	if (locale === "fi") return fi_landing_demo_subtitle(inputs)
	if (locale === "da") return da_landing_demo_subtitle(inputs)
	if (locale === "sv") return sv_landing_demo_subtitle(inputs)
	return en_landing_demo_subtitle(inputs)
});